import { render, staticRenderFns } from "./ScanFormDPAdmin.vue?vue&type=template&id=61a3860a&scoped=true"
import script from "./ScanFormDPAdmin.vue?vue&type=script&lang=js"
export * from "./ScanFormDPAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a3860a",
  null
  
)

export default component.exports